import {Provider as JotaiProvider} from 'jotai';
import {ThemeProvider as MuiThemeProvider} from '@mui/material/styles';
import MuiThemeConfig from "./utils/mui_theme.ts"
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {
    experimental_extendTheme as materialExtendTheme,
    Experimental_CssVarsProvider as MaterialCssVarsProvider,
    THEME_ID as MATERIAL_THEME_ID,
} from '@mui/material/styles';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/material/CssBaseline';
import GeneralComponent from "./components/general_component.tsx";
import SimpleSnackbarList from "@/ui/SimpleSnackbarList.tsx";
import 'moment/locale/ro';
import 'moment/locale/ru';
import CrApplyedDiffNumber from "@/ui/modals/CrApplyedDiffNumber.tsx";
import '@aws-amplify/ui-react/styles.css';
import GoToKYC from "@/ui/modals/GoToKYC.tsx";
import PromoSubscribe from "@/ui/modals/PromoSubscribe.tsx";
// import LoadMapScript from "@/components/LoadMapScript.tsx";
const materialTheme = materialExtendTheme();
import 'swiper/css';
import 'swiper/css/navigation';
import SignContractErr from "@/ui/modals/SignContractErr.tsx";
import { ThemeProvider } from '@aws-amplify/ui-react';
import {useTranslation} from "react-i18next";
// import dayjs from 'dayjs';
import 'dayjs/locale/ro';
import 'dayjs/locale/ru';
import ScheduleModal from "@/ui/modals/ScheduleModal.tsx";
import { roRO, ruRU } from '@mui/x-date-pickers/locales';


const App = () => {
    const theme = MuiThemeConfig;
    const {i18n} = useTranslation()
    const l_txt = i18n.language === "ro" ? roRO.components.MuiLocalizationProvider.defaultProps.localeText : ruRU.components.MuiLocalizationProvider.defaultProps.localeText
    // dayjs.locale(i18n.language);
    
    return (
        <ThemeProvider>
            {/*<LoadMapScript>*/}
                <JotaiProvider>
                    <MuiThemeProvider theme={theme}>
                        <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale={i18n.language}
                            localeText={l_txt}
                        >
                            <MaterialCssVarsProvider theme={{ [MATERIAL_THEME_ID]: materialTheme }}>
                                <JoyCssVarsProvider>
                                    <CssBaseline enableColorScheme />

                                    <GeneralComponent>
                                        
                                        <SimpleSnackbarList />
                                        <CrApplyedDiffNumber />
                                        <GoToKYC />
                                        <PromoSubscribe />
                                        <SignContractErr />
                                        <ScheduleModal />
                                        
                                    </GeneralComponent>

                                </JoyCssVarsProvider>
                            </MaterialCssVarsProvider>
                        </LocalizationProvider>
                    </MuiThemeProvider>
                </JotaiProvider>
            {/*</LoadMapScript>*/}
        </ThemeProvider>
    )
}

export default App;
